export default class Layout {
    constructor() {
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        this.headerElement = document.getElementById('header')
        this.footerElement = document.getElementById('footer')
        this.navTabElement = document.getElementById('nav-tab')
        this.signElement = document.getElementById('sign-element')
        this.detailsElement = document.getElementById('details-element')
        this.documentElement = document.getElementById('document-element')
        this.documentElementContainer = document.getElementById('document-element-container')

    }
    init() {

        this.setLayout()
        this.setContent()
        window.addEventListener('resize', ()=> {
            this.setLayout()
            this.setContent()
        })
    }

    setLayout() {
        const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        const headerHeight = this.headerElement.offsetHeight
        const footerHeight = this.footerElement.offsetHeight
        const navTabHeight = this.navTabElement.offsetHeight
        this.setContentHeight(windowHeight - headerHeight - footerHeight - navTabHeight - 75)
    }
    setContentHeight(height) {
        this.signElement.style.height = (height + 75) + 'px'
        this.documentElementContainer.style.height = height + 'px'
    }
    setContent() {
        let navLinks = document.getElementsByClassName('scroll-to')
        let clickEvent = (event) => {
            event.preventDefault()
            for (let i = 0; i < navLinks.length; i++) {
                navLinks[i].classList.remove('active');
            }
            event.target.classList.add('active')
           let targetElementId = event.target.getAttribute('href').replace('#','')

           let links = document.querySelectorAll('[href="#' + targetElementId + '"]')
            for (let i = 0; i < links.length; i++) {
                links[i].classList.add('active')
            }
            this.activateContentElement(targetElementId)
            if(event.target.dataset.hasOwnProperty('scroll')) {
                if(document.getElementById(event.target.dataset['scroll'])) {
                    setTimeout(()=>{
                        document.getElementById(event.target.dataset['scroll']).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
                    },150)
                }
            }
        }

        for (let i = 0; i < navLinks.length; i++) {
            navLinks[i].addEventListener('click', clickEvent, false);
        }
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        if(windowWidth < 992) {
            this.signElement.classList.add('d-none')
            this.detailsElement.classList.add('d-none')
            this.documentElement.classList.remove('d-none')
            window.dispatchEvent(new CustomEvent('content-element-show',{ detail: 'document-element' }))
        }else {
            this.documentElement.classList.remove('d-none')
            this.signElement.classList.remove('d-none')
            this.detailsElement.classList.remove('d-none')
        }
    }
    activateContentElement(id) {
        if(id === 'sign-element') {
            this.signElement.classList.remove('d-none')
            this.detailsElement.classList.add('d-none')
            this.documentElement.classList.add('d-none')

        }
        if(id === 'document-element') {
            this.signElement.classList.add('d-none')
            this.detailsElement.classList.add('d-none')
            this.documentElement.classList.remove('d-none')

        }
        if(id === 'details-element') {
            this.signElement.classList.add('d-none')
            this.detailsElement.classList.remove('d-none')
            this.documentElement.classList.add('d-none')

        }
        window.dispatchEvent(new CustomEvent('content-element-show',{ detail: id }))
    }
}
